"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.concentrationLimitPointerMethods = exports.calculateStandardConcentrationLimitKickoutsForCustomBaseFieldNumerator = void 0;
/* eslint-disable camelcase */
const lodash_1 = __importDefault(require("lodash"));
const calc_agent_1 = require("@finley-technologies/calc-agent");
const common_1 = require("@finley-technologies/common");
const NUMERATOR_FIELD = 'installment_balances';
// this method uses given baseField as numerator (instead of exposure) to caluclate concentration limit kickouts
const calculateStandardConcentrationLimitKickoutsForCustomBaseFieldNumerator = ({ concentrationReceivables, totalConcentrationExposure, concentrationLimit, concentrationLimitValueType, field, }) => {
    const normalizedConcentrationLimit = (0, calc_agent_1.getNormalizedConcentrationLimit)({
        concentrationLimit,
        concentrationLimitValueType,
        totalConcentrationExposure,
    });
    let concentrationAmount = 0;
    concentrationReceivables.forEach((rec) => {
        const value = rec.baseFields[field];
        (0, common_1.finleyAssert)(typeof value === 'number', `calculateStandardConcentrationLimitKickoutsForCustomBaseFieldNumerator: baseFields.${field} must be a number. Found [${rec.baseFields[field]}}]`);
        if (rec.eligibilityFields.isEligible) {
            concentrationAmount += value;
        }
    });
    const exposureLimit = lodash_1.default.round(totalConcentrationExposure * normalizedConcentrationLimit, 10);
    // We'll multiply each loanTape by the concentration factor to get the
    // updated borrowing base amount
    const concentrationFactor = Math.max(concentrationAmount - exposureLimit, 0) > 0
        ? 1 - common_1.utils.divideByOrZero(exposureLimit, concentrationAmount)
        : 0;
    const kickouts = (0, calc_agent_1.getConcentrationLimitKickouts)({
        concentrationFactor,
        concentrationReceivables,
    });
    return {
        kickouts,
        calculations: {
            concentrationAmount,
            concentrationLimit: normalizedConcentrationLimit,
            concentration: lodash_1.default.round(common_1.utils.divideByOrZero(concentrationAmount, totalConcentrationExposure), 10),
        },
    };
};
exports.calculateStandardConcentrationLimitKickoutsForCustomBaseFieldNumerator = calculateStandardConcentrationLimitKickoutsForCustomBaseFieldNumerator;
/*
so essentially there are some receivables that are "installment loans" where a portion of the exposure  is made up of installmentBalances . The concentration limit is expected to identify the loans that have installmentBalances > 0, and sum these up to be the numerator of the concentration limit test. Typically, the tests are set up to identify these receivables and sum up the full exposure for the numerator, but here we are only looking to have a portion of the exposure as the numerator in the test
*/
exports.concentrationLimitPointerMethods = [
    // any single receivable cannot be more than 20%
    {
        method: 'brimFinancialAtlasSp1.installmentPayAccountsUpTo5Percent',
        pointerImplementation: ({ concentrationReceivables, valueConfig, totalConcentrationExposure, }) => {
            (0, common_1.finleyAssert)(valueConfig.type === 'number', `unsupported concentration limit type in concentration limit singleReceivableLimit`);
            const concentrationLimit = valueConfig.limit;
            const concentrationLimitValueType = valueConfig.valueType;
            const result = (0, exports.calculateStandardConcentrationLimitKickoutsForCustomBaseFieldNumerator)({
                concentrationReceivables,
                totalConcentrationExposure,
                concentrationLimit,
                concentrationLimitValueType,
                field: NUMERATOR_FIELD,
            });
            return result;
        },
    },
];
//# sourceMappingURL=concentrationLimitPointerMethods.js.map